/**
 * The address of the Core this panel talks to (D-217), decided when the panel is built
 * (VITE_API_URL), as in AddVPN:
 *
 *   ''                         the panel's own origin — its nginx forwards /api, /auth and
 *                              /broadcasting to Core (development, a single-name server)
 *   'https://core.example.com' one fixed address
 *   'https://core.{host}'      derived from the name the panel was opened at: one build
 *                              served under several names talks to the Core beside each
 *
 * The websocket and the media a page embeds (pictures, recordings, fonts) stay on the panel's
 * origin either way: its nginx forwards them, with the session's cookie scoped to both names.
 *
 * Kept free of `window` and `import.meta` so it can be checked outside a browser.
 *
 * @param {string|undefined} configured  the value of VITE_API_URL
 * @param {string} host                  the page's host, `window.location.host`
 * @returns {string} an address without a trailing slash, or '' for the page's own origin
 */
export function resolveApiUrl(configured, host) {
  const value = String(configured ?? '').trim()
  if (value === '') return ''
  return value.split('{host}').join(host).replace(/\/+$/, '')
}

/** A URL Core gave, as a path on the panel's origin: what a page embeds goes through the panel (see above). */
export function onPanelOrigin(url) {
  return typeof url === 'string' ? url.replace(/^https?:\/\/[^/]+(?=\/)/i, '') : url
}
